const styles = {
  root: {
    paddingY: { xs: 2, md: 4 },
  },

  title: {
    fontWeight: 600,
    marginBottom: 3,
  },

  subtitle: {
    marginBottom: 3,
    whiteSpace: 'pre-line',
  },

  link: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& svg': {
      marginRight: 2,
      fill: 'primary.main',
    },
  },

}

export default styles
